import { includes } from 'lodash';
import moment from 'moment';
import JOB_STATUSES from './jobStatuses.json';
import JOBS from './jobs.json';

const { POLLING: { EXTRA_POLL_TIME, UNKNOWN_POLL_TIME, MAX_POLL_TIME } } = JOBS;

export function calculateNextBestJobUpdate(completedJobFiles, lowestItemCount) {
  const ratios = completedJobFiles.filter(job => (
    job.createdAt && job.updatedAt && job.itemCount
  )).map((job) => {
    const start = moment(job.createdAt);
    const end = moment(job.updatedAt);

    const duration = end.diff(start, 'seconds');

    return duration / job.itemCount;
  });

  if (ratios.length === 0) { return null; }

  const ratio = ratios.reduce((a, b) => a + b, 0) / ratios.length;

  return ratio * lowestItemCount;
}

export default function buildPollingIntervalState(jobs) {
  const jobsToPoll = jobs.filter(
    ({ status }) =>
      [JOB_STATUSES.PENDING, JOB_STATUSES.STARTED].indexOf(status) !== -1,
  );

  const jobIDsToPoll = jobsToPoll.map(({ id }) => id);

  let nextPollInSeconds = UNKNOWN_POLL_TIME;

  if (jobIDsToPoll.length > 0) {
    const completedJobFiles = jobs
      .filter(({ status }) => includes(JOB_STATUSES.FINISHED, status))
      .reduce((all, job) => all.concat(job.files), []);

    if (completedJobFiles.length > 0) {
      const itemCounts = jobsToPoll.reduce(
        (all, job) => all.concat(job.files.map(file => file.itemCount)),
        [],
      );

      const lowestPolledItemCount = Math.min(...itemCounts);

      const calculatedTime = calculateNextBestJobUpdate(
        completedJobFiles, lowestPolledItemCount,
      );

      if (calculatedTime) {
        nextPollInSeconds = Math.min(
          calculatedTime + EXTRA_POLL_TIME,
          MAX_POLL_TIME,
        );
      }
    }
  }

  return {
    jobs,
    nextPoll: {
      inSeconds: nextPollInSeconds,
      timeOfLastRetrieval: moment(),
    },
  };
}